export const existsSync = () => false;
export const readFile = async () => {
    throw new Error("Not supported");
};
export const writeFile = async () => {
    throw new Error("Not supported");
};
//# sourceMappingURL=index-browser.mjs.map